// ReminderNotification.js
import { useEffect, useState } from "react";
import { socket } from "./Pages/Support";
import { Link } from "react-router-dom";
//import { io } from "socket.io-client";
import "./App.css";

const ReminderNotification = () => {
  const [reminder, setReminder] = useState(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    socket.on("reminderNotification", (data) => {
      // console.log("Meeting Reminder:", data);
      setReminder(data);
      setShow(true);
      document.body.style.overflow = "hidden"; // ❄️ Freeze screen
    });

    return () => {
      socket.off("reminderNotification");
      document.body.style.overflow = "auto"; // Restore scroll on cleanup
    };
  }, []);

  const handleClose = () => {
    setShow(false);
    document.body.style.overflow = "auto"; // ✅ Unfreeze screen
  };

  if (!show || !reminder) return null;

  return (
    <div className="reminder-overlay">
      <div className="reminder-popup">
        <button className="close-btn" onClick={handleClose}>
          ×
        </button>
        <h4>🕒Reminder Notification</h4>
        <p>
          <strong>{reminder.title}</strong> is scheduled at{" "}
          <strong>{new Date(reminder.time).toLocaleString()}</strong>
        </p>
        <Link
          to={`/DatelsLeads/${reminder.leadId}`}
          className="btn btn-sm btn-primary"
          onClick={() => setShow(false)}
        >
          Click here for more detail
        </Link>
      </div>
    </div>
  );
};

export default ReminderNotification;
